import { VideoCallRecordingService } from '@services/videoCallRecordingService';
import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

export const useSyncVideoCallRecordings = () => {
  return useMutation({
    mutationFn: () => VideoCallRecordingService.sync(),
    onSuccess: () => {
      message.success('Video call recordings synced successfully');
    },
    onError: () => {
      message.error('Failed to sync video call recordings');
    },
  });
};
